import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ExtractorConfigDto, ExtractorConfigUpdateInput } from '@upme/contracts';
import { api } from '../../app/api-client';
import { extractorConfigKey } from './queries';

export function useUpdateExtractorConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: ExtractorConfigUpdateInput) =>
      api.patch('admin/extractor-config', { json: body }).json<ExtractorConfigDto>(),
    onSuccess: (data) => qc.setQueryData([...extractorConfigKey], data),
  });
}
